<template>
  <section style="padding: 0 10px !important;" :style="isMobile ? '' : 'width: 75%; margin: auto'">
    <h1 class="app-title" style="margin-top: 10px">{{ $props.editMode ? 'Editar' : 'Cadastrar' }} Vaquejada</h1>
    <v-form style="height: calc(100dvh - 170px); overflow-y: auto;" ref="form" v-model="valid">
      <v-stepper alt-labels hide-actions height="90%" style="overflow-y: auto" v-model="step" :items="stepsCadastro">
        <template #item.1>
          <v-text-field
            v-model="dados.nome"
            density="compact"
            label="Nome da Vaquejada"
            variant="outlined"
            style="margin-top: 10px"
            :rules="[(v) => !!v || 'Nome é obrigatório']"
          />

          <div style="position: relative" v-if="dados.logo">
            <v-img
              cover
              :src="getUrl + '/images/vaquejadas/' + dados.logo"
              style="border-radius: 7px; margin-bottom: 8px"
              max-height="150"
              max-width="100%"
            />
            <v-btn style="position: absolute; top: 0; right: 0" variant="elevated" color="red" icon="mdi-delete" @click="dados.logo = null" />
          </div>

          <v-file-input
            ref="inputImagem"
            v-model="imageUpload"
            v-show="imageUpload"
            :rules="[value => {return !value || !value.length || value[0].size < 4000000 || 'O tamanho da imagem não pode ser maior que 4 MB!'},]"
            accept="image/png, image/jpeg, image/bmp, image/webp"
            label="Imagem da Vaquejada"
            placeholder="Selecione a Imagem da Vaquejada"
            variant="outlined"
            prepend-icon=""
            prepend-inner-icon="mdi-camera"
            density="compact"
            show-size
            counter
            counter-size-string="Tamanho: {1}"
            style="margin-bottom: 8px"
          />

          <p v-if="isErrorLogo" style="color: #b00020">
            Logo da vaquejada é obrigatório!
          </p>

          <v-btn
            v-show="!dados.logo"
            :text="$props.editMode ? 'Selecione a nova imagem' : 'Selecione a imagem'"
            variant="elevated"
            color="primary"
            block
            prepend-icon="mdi-camera"
            style="margin-bottom: 15px"
            @click="selecionarImagem"
          />
        </template>
        <template #item.2>
          <div id="editor-description" :style="isMobile ? 'height: fit-content; max-height: 250px;' : 'height: fit-content !important; max-height: 600px !important;'" style="margin-bottom: 25px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px; overflow-y: scroll" />
        </template>
        <template #item.3>
          <v-text-field
            v-model="dados.dataInicio"
            density="compact"
            label="Data de Início da Vaquejada"
            placeholder="dd/mm/aaaa"
            type="date"
            variant="outlined"
            :rules="[(v) => !!v || 'Data de Início é obrigatória']"
            style="margin-top: 15px"
          />

          <!--v-text-field
            v-model="dados.dataFim"
            density="compact"
            label="Data do Encerramento da Vaquejada"
            placeholder="dd/mm/aaaa"
            type="date"
            variant="outlined"
            :rules="[(v) => !!v || 'Data do Encerramento é obrigatória']"
          /-->

          <fieldset style="padding: 10px; border-radius: 5px; margin-bottom: 15px; border-color: #1867C0" v-if="dados.dataInicio && dados.dataInicio.length === 10">
            <legend style="margin-left: 10px; padding: 0 5px">Preencha a quantidade de senhas</legend>

            <v-text-field
              v-for="i in dados.quantidadeSenhas.length"
              :key="i"
              v-model="dados.quantidadeSenhas[i - 1]"
              density="compact"
              :label="`Quantidade de Senhas no dia ${i}`"
              type="number"
              variant="outlined"
              :rules="[(v) => !!v || 'Quantidade de Senhas é obrigatória', (v) => v > 0 || 'Quantidade de Senhas deve ser maior que 0']"
            >
              <template #append>
                <v-icon v-if="i > 1" color="error" icon="mdi-delete" @click="removeQuantidadeSenhas(i - 1)" />
              </template>
            </v-text-field>

            <v-btn
              @click="addQuantidadeSenhas"
              color="primary"
              prepend-icon="mdi-plus"
              size="small"
              variant="elevated"
              text="Adicionar Dia"
              class="text-none"
            />
          </fieldset>
        </template>
        <template #item.4>
          <v-text-field
            v-model="dados.dataHoraEncerramento"
            density="compact"
            label="Data e Hora de Encerramento das Vendas"
            placeholder="dd/mm/aaaa"
            type="datetime-local"
            variant="outlined"
            :rules="[(v) => !!v || 'Data do Encerramento é obrigatória']"
            style="margin-top: 15px"
          />

          <v-text-field
            v-model="dados.limiteSenhasVaqueiro"
            density="compact"
            label="Limite de Senhas por Vaqueiro"
            :hint="$props.editMode ? `Alterar o limite não afetará as senhas já adquiridas. O novo limite só será aplicado a novas aquisições.` : `Define o limite máximo de senhas por vaqueiro (se deixar vazio, ficará ilimitado.)`"
            type="number"
            variant="outlined"
            style="margin-bottom: 8px"
          />

          <v-text-field
            v-model="dados.valorBoi"
            density="compact"
            label="Preço do Boi de TV"
            prefix="R$"
            step="0.01"
            type="number"
            variant="outlined"
            :rules="[(v) => v >= 0 || 'Preço do Boi de TV deve ser maior ou igual que 0']"
            style="margin-bottom: 8px"
            :hint="$props.editMode ? `Alterar o preço do boi TV não afetará as senhas já adquiridas. O novo preço só será aplicado a novas aquisições.` : ``"
          />
        </template>
        <template #item.5>
          <v-text-field
            v-model="dados.numeroClassificacoes"
            density="compact"
            label="Número de Classificações"
            type="number"
            variant="outlined"
            :rules="[(v) => !!v || 'Quantidade de Classificações é obrigatória']"
            style="margin-top: 15px"
          />

          <v-text-field
            v-model="dados.numeroDisputas"
            density="compact"
            label="Número de Disputas"
            type="number"
            variant="outlined"
            :rules="[(v) => !!v || 'Quantidade de Disputas é obrigatória']"
          />

          <fieldset style="padding: 10px; border-radius: 5px; margin-bottom: 15px;">
            <legend style="margin-left: 10px; padding: 0 5px">Localização</legend>

            <v-select
              v-model="estadoSelecionado"
              :items="estados"
              density="compact"
              :no-data-text="`Nenhum Estado Encontrado`"
              label="Estado"
              return-object
              variant="outlined"
              :rules="[(v) => !!v || 'Estado é obrigatória']"
            />

            <v-select
              v-if="estadoSelecionado"
              v-model="dados.idCity"
              :item-props="itemProps"
              :items="cidades"
              density="compact"
              :no-data-text="`Nenhuma Cidade Encontrada`"
              label="Cidade"
              :loading="loadingCidades"
              return-object
              variant="outlined"
              :rules="[(v) => !!v || 'Cidade é obrigatória']"
            />
          </fieldset>
        </template>
        <template #item.6>
          <h4>Adicione as categorias</h4>
          <v-form ref="formCategoria" v-model="validCategoria">
            <fieldset style="padding: 10px; border-radius: 5px; margin-bottom: 15px">
              <legend style="margin-left: 10px; padding: 0 5px">Selecione as Categorias</legend>

              <v-select
                :items="categorias"
                v-model="dadosCategoria.categoria"
                :no-data-text="`Nenhuma Categoria Encontrada`"
                item-title="nome"
                item-value="id"
                density="compact"
                label="Categorias"
                variant="outlined"
                return-object
                :rules="[(v) => !!v || 'Categoria é obrigatória']"
              />

              <div style="width: 100%; display: flex; justify-content: space-evenly; flex-direction: row">
                <v-text-field
                  v-model="dadosCategoria.valorAntecipado"
                  density="compact"
                  label="Valor Antecipado"
                  prefix="R$"
                  step="0.01"
                  type="number"
                  variant="outlined"
                  style="margin-left: 5px"
                  hint="Válido até o encerramento das vendas"
                  persistent-hint
                />

                <v-text-field
                  v-model="dadosCategoria.valor"
                  density="compact"
                  label="Valor no Evento"
                  prefix="R$"
                  step="0.01"
                  type="number"
                  variant="outlined"
                  :rules="[(v) => !!v || 'Valor é obrigatório']"
                  style="margin-right: 5px"
                  persistent-hint
                  hint="Valor praticado no dia do evento"
                />
                <!--v-text-field
                  v-model="dadosCategoria.limiteSenhas"
                  density="compact"
                  label="Limite"
                  type="number"
                  variant="outlined"
                  style="margin-left: 5px"
                  :rules="[(v) => !!v || 'Limite é obrigatório']"
                /-->
              </div>

              <v-btn @click="addCategoria" color="success" prepend-icon="mdi-plus" size="small" variant="outlined" text="Adicionar" />
            </fieldset>
          </v-form>

          <v-list density="compact" style="display: flex; flex-direction: row; flex-wrap: wrap">
            <v-list-item
              v-for="(categoria, i) in dados.categorias"
              :key="i"
              density="compact"
              border
              rounded
              style="margin-bottom: 5px; width: fit-content; margin-right: 10px"
              :style="`${$props.editMode ? 'background-color: #25ac1c' : 'background-color: #3f84d2'}`"
              base-color="white"
            >
              <v-list-item-title>{{ categoria.categoria.nome }}</v-list-item-title>
              <v-list-item-subtitle v-if="categoria.valorAntecipado">Valor Antecipado: {{ Number(categoria.valorAntecipado).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ categoria.valorAntecipado ? 'Valor: ' : '' }}{{ Number(categoria.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="false">Limite {{ categoria.limiteSenhas }}</v-list-item-subtitle>
              <template #append>
                <v-btn v-if="$props.editMode" color="primary" icon="mdi-pencil" variant="text" @click="openDialogEditCategoria(categoria)" />
                <v-btn color="red" icon="mdi-close" variant="text" @click="removeExistingCategoria(i)" />
              </template>
            </v-list-item>

            <v-list-item
              v-for="(categoria, i) in newCategorias"
              :key="i"
              density="compact"
              border
              rounded
              style="margin-bottom: 5px; background-color: #3f84d2"
              base-color="white"
            >
              <v-list-item-title>{{ categoria.categoria.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ Number(categoria.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="false">Limite {{ categoria.limiteSenhas }}</v-list-item-subtitle>
              <template #append>
                <v-btn color="red" icon="mdi-close" variant="text" @click="newCategorias.splice(i, 1)" />
              </template>
            </v-list-item>
          </v-list>
        </template>
        <template #item.7>
          <v-select
            v-model="dados.tipoValor"
            :items="[{ title: 'Valor Fixo (ex: R$ 25,00)', value: 1 }, { title: 'Porcentagem (ex: 10%)', value: 2 }]"
            density="compact"
            label="Selecione o Tipo de Comissão"
            variant="outlined"
            style="margin-top: 10px"
            :rules="[(v) => !!v || 'Tipo de Comissão é obrigatório']"
          />

          <v-text-field
            v-if="dados.tipoValor"
            v-model="dados.valor"
            density="compact"
            type="number"
            :prefix="dados.tipoValor === 1 ? 'R$' : '%'"
            step="0.01"
            :label="dados.tipoValor === 1 ? 'Valor da Comissão' : 'Porcentagem da Comissão'"
            variant="outlined"
            style="margin-top: 10px"
            :rules="[(v) => !!v || (dados.tipoValor === 1 ? 'Valor da Comissão' : 'Porcentagem da Comissão') + ' é obrigatório', (v) => v >= 0]"
          />

          <v-select
            v-model="dados.destinatarioPix"
            label="Selecione o Destinatário Pix"
            :item-props="selectDestinatarioPixItemProps"
            :items="destinatariosPix"
            density="compact"
            variant="outlined"
            style="margin-top: 10px"
            :rules="[(v) => !!v || 'Destinatário é obrigatório']"
          />
        </template>
        <template #item.8>
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dados.tipoDesconto"
                :items="[{ title: 'Valor Fixo', value: 1 }, { title: 'Porcentagem', value: 2 }, { title: 'Sem Desconto', value: 3 }]"
                density="compact"
                label="Existe desconto por múltiplas senhas?"
                variant="outlined"
                color="primary"
                style="margin-top: 10px"
                :rules="[(v) => !!v || 'Tipo de Desconto é obrigatório']"
              >
                <v-radio v-for="item in [{ title: 'Valor Fixo', value: 1 }, { title: 'Porcentagem', value: 2 }, { title: 'Sem Desconto', value: 3 }]" :key="item.value" :label="item.title" :value="item.value" />
              </v-radio-group>

              <v-text-field
                v-if="dados.tipoDesconto && dados.tipoDesconto !== 3"
                v-model="dados.desconto"
                density="compact"
                type="number"
                :prefix="dados.tipoDesconto === 1 ? 'R$' : '%'"
                step="0.01"
                :label="dados.tipoDesconto === 1 ? 'Valor do Desconto' : 'Porcentagem do Desconto'"
                variant="outlined"
                style="margin-top: 10px"
                :rules="[(v) => !!v || (dados.tipoDesconto === 1 ? 'Valor do Desconto' : 'Porcentagem do Desconto') + ' é obrigatório', (v) => v >= 0]"
              />

              <v-text-field
                v-if="dados.desconto && dados.tipoDesconto !== 3"
                v-model="dados.numeroSenhasDesconto"
                density="compact"
                type="number"
                label="Número de Senhas para receber o Desconto"
                variant="outlined"
                style="margin-top: 10px"
                :rules="[(v) => !!v || 'Número de Senhas para receber o Desconto é obrigatório', (v) => v >= 0 || 'Número de Senhas para receber o Desconto deve ser maior ou igual a 0']"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-radio-group
                v-if="dados.numeroSenhasDesconto && dados.tipoDesconto !== 3"
                v-model="descontoTodasSenhas"
                density="compact"
                variant="outlined"
                color="primary"
                style="margin-top: 10px"
                :items="[{ title: 'Todas as Senhas', value: 1 }, { title: 'Categorias Específicas', value: 2 }]"
              >
                <template #label>
                  <div style="text-wrap: wrap;">
                    Desconto para todas as senhas ou para categorias específicas?
                  </div>
                </template>
                <v-radio v-for="item in [{ title: 'Todas as Senhas', value: 1 }, { title: 'Categorias Específicas', value: 2 }]" :key="item.value" :label="item.title" :value="item.value" />
              </v-radio-group>

              <h4 v-if="descontoTodasSenhas && descontoTodasSenhas === 2 && dados.tipoDesconto !== 3 && dados.numeroSenhasDesconto && Number(dados.numeroSenhasDesconto) > 0">
                Selecione as Categorias que poderão receber o desconto
              </h4>
              <v-chip-group
                v-if="descontoTodasSenhas && descontoTodasSenhas === 2 && dados.tipoDesconto !== 3 && dados.numeroSenhasDesconto && Number(dados.numeroSenhasDesconto) > 0"
                v-model="dados.categoriasDescontoVaquejada"
                multiple
                column
                density="compact"
                variant="outlined"
                color="primary"
                style="margin-top: 10px"
              >
                <v-chip v-for="categoria in dados.categorias" :variant="dados.categoriasDescontoVaquejada.includes(categoria.categoria.id || 0) ? 'elevated' : 'outlined'" :key="categoria.categoria.id" :text="categoria.categoria.nome" :value="categoria.categoria.id">
                  <template #append>
                    <v-icon
                      icon="mdi-close"
                      color="red"
                      v-if="dados.categoriasDescontoVaquejada.includes(categoria.categoria.id || 0)"
                    />
                  </template>
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </template>
      </v-stepper>

      <div style="display: flex; height: 10%; align-items: center; padding: 0 10px; box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.3);">
        Passo {{ step }} de {{ stepsCadastro.length }}
        <v-spacer />
        <v-btn
          color="primary"
          variant="tonal"
          prepend-icon="mdi-chevron-left"
          size="small"
          style="margin-right: 10px;"
          text="Voltar"
          :disabled="loading || step === 1"
          @click="step = step - 1"
        />
        <v-btn v-if="$props.editMode" :disabled="disabledBtnSalvar" :loading="loading" variant="elevated" @click="avancar" :color="step === 8 ? 'success' : 'primary'" :append-icon="step === 8 ? 'mdi-content-save' : 'mdi-chevron-right'" size="small" :text="step === 8 ? 'Salvar' : 'Avançar'" />
        <v-btn v-else :disabled="disabledBtnSalvar" variant="elevated" @click="avancar" color="primary" append-icon="mdi-chevron-right" size="small" text="Avançar" />
      </div>
    </v-form>
    <v-snackbar v-model="snackbar.active" :color="snackbar.color" location="top">
      <template #default> {{ snackbar.text }} </template>
    </v-snackbar>

    <v-dialog v-if="$props.editMode" v-model="dialogEditCategoria.active" width="auto">
      <v-card class="ma-auto" :width="getWidthScreen">
        <v-form ref="formEditCategoria" v-model="dialogEditCategoria.validDialogCategoria">
          <v-card-title>
            Editar Categoria
            <v-btn
              color="red"
              icon="mdi-close"
              variant="text"
              @click="dialogEditCategoria.active = false"
              style="position: absolute; top: 0; right: 0;"
            />
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="dialogEditCategoria.categoria.categoria.nome"
              density="compact"
              variant="outlined"
              readonly
            />
            <v-text-field
              v-model="dialogEditCategoria.categoria.valorAntecipado"
              density="compact"
              prefix="R$"
              step="0.01"
              label="Valor Antecipado"
              type="number"
              variant="outlined"
              style="margin-right: 5px"
            />
            <v-text-field
              v-model="dialogEditCategoria.categoria.valor"
              density="compact"
              prefix="R$"
              step="0.01"
              label="Valor no Evento"
              type="number"
              variant="outlined"
              style="margin-right: 5px"
              :rules="[(v) => !!v || 'Valor é obrigatório']"
            />
            <!--div style="width: 100%; display: flex; justify-content: space-evenly; flex-direction: row">
              <v-text-field
                v-model="dialogEditCategoria.categoria.limiteSenhas"
                density="compact"
                label="Limite"
                type="number"
                variant="outlined"
                style="margin-left: 5px"
                :rules="[(v) => !!v || 'Limite é obrigatório']"
              />
            </div>
            <p>
              <span class="font-weight-bold">Observação: </span>
              <span style="font-size: 11px; font-weight: normal; opacity: 0.7">
                Ao editar o valor ou o limite, as senhas já adquiridas dessa categoria não serão afetadas.
              </span>
            </p-->
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" text="Salvar" @click="editarCategoria" :disabled="!activeBtnSalvarCategoria" />
            <v-btn color="red" text="Cancelar" @click="dialogEditCategoria.active = false" />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddDestinatarioPix" width="auto" transition="dialog-bottom-transition" persistent>
      <v-card class="ma-auto" width="300px">
        <v-card-title>
          Adicionar Destinatário Pix
          <v-btn
            color="red"
            icon="mdi-close"
            variant="text"
            @click="dialogAddDestinatarioPix = false"
            style="position: absolute; top: 0; right: 0;"
          />
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="formDestinatarioPix.nome"
            density="compact"
            label="Nome do Destinatário Pix"
            variant="outlined"
            :rules="[(v) => !!v || 'Nome do Destinatário Pix é obrigatório']"
          />

          <v-text-field
            v-model="formDestinatarioPix.chavePix"
            density="compact"
            label="Chave Pix"
            variant="outlined"
            :rules="[(v) => !!v || 'Chave Pix é obrigatório']"
          />

          <v-text-field
            v-model="formDestinatarioPix.contato"
            density="compact"
            label="Contato (Whatsapp)"
            placeholder="Ex: (00) 0 0000-0000"
            v-mask="'(##) # ####-####'"
            variant="outlined"
            :rules="[(v) => !!v || 'Contato é obrigatório']"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" text="Salvar" @click="adicionarDestinatarioPix" :loading="loadingFormDestinatarioPix" />
          <v-btn color="red" text="Cancelar" @click="dialogAddDestinatarioPix = false" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCheckout" fullscreen persistent>
      <v-card style="height: 100%">
        <v-card-title style="height: 10%; text-align: center; font-size: 28px">Resumo da Vaquejada</v-card-title>
        <v-card-text style="height: 80% !important; overflow-y: scroll">
          <v-row>
            <v-col cols="12" md="3">
              <v-img :src="getImageUploadURL" cover width="100%" />
              <div style="width: fit-content; margin: 10px auto">
                <v-btn prepend-icon="mdi-pencil" color="primary" text="Mudar Imagem" @click="goToStep(1)" />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <span style="color: grey">Descrição</span>
              <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(2)" />
              <v-divider />
              <div v-html="getDescricao" />
            </v-col>
            <v-col cols="12" md="3">
              <div style="display: flex; flex-direction: column">
                <div>
                  <span style="color: grey">Nome</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(1)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.nome }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Data de Início</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(3)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.dataInicio.split('-').reverse().join('/') }}</span>
                </div>

                <div>
                  <fieldset style="padding: 10px; border-radius: 10px; margin-top: 10px">
                    <legend style="margin-left: 10px">Senhas</legend>

                    <div style="display: flex; flex-direction: column">
                      <div v-for="(dia, i) in getDiasSenhasWithDate" :key="i" :style="(i + 1) !== getDiasSenhasWithDate.length ? 'margin-bottom: 15px' : ''">
                        <span style="color: grey">{{ i + 1 }}º dia ({{ dia.data }})</span>
                        <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(3)" />
                        <v-divider />
                        <span style="font-weight: bold">{{ dia.quantidade }} senhas</span>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Encerramento das Vendas</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(4)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.dataHoraEncerramento.slice(0, 10).split('-').reverse().join('/') }} às {{ dados.dataHoraEncerramento.slice(11, 16) }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Limite de Senhas por Vaqueiro</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(4)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.limiteSenhasVaqueiro ? dados.limiteSenhasVaqueiro + ' senhas' : 'Sem Limite' }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Preço do Boi de TV</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(4)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ Number(dados.valorBoi).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Nº de Classificações</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(5)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.numeroClassificacoes }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Nº de Disputas</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(5)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.numeroDisputas }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Localização</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(5)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ getCidade }}</span>
                </div>

                <div>
                  <fieldset style="padding: 10px; border-radius: 10px; margin-top: 10px">
                    <legend style="margin-left: 10px">Categorias</legend>

                    <div style="display: flex; flex-direction: column">
                      <div v-for="(categoria, i) in dados.categorias" :key="i" :style="(i + 1) !== dados.categorias.length ? 'margin-bottom: 15px' : ''">
                        <span style="color: grey">{{ categoria.categoria.nome }}</span>
                        <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(6)" />
                        <v-divider />
                        <span style="font-weight: bold">{{ Number(categoria.valor).toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) }}</span>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Comissão ({{ dados.tipoValor === 1 ? 'Valor Fixo' : 'Porcentagem %' }})</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(7)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.tipoValor === 1 ? Number(dados.valor).toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) : dados.valor + '%' }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Destinatário Pix</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(7)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ destinatariosPix.find(d => d.id === dados.destinatarioPix).nome }}</span>
                  <br>
                  <span style="font-weight: normal">{{ destinatariosPix.find(d => d.id === dados.destinatarioPix).chavePix }}</span>
                </div>

                <div style="margin-top: 10px">
                  <span style="color: grey">Tipo de Desconto</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(8)" />
                  <v-divider />
                  <span style="font-weight: bold" v-if="dados.tipoDesconto === 1">Valor Fixo R$</span>
                  <span style="font-weight: bold" v-if="dados.tipoDesconto === 2">Porcentagem %</span>
                  <span style="font-weight: bold" v-if="dados.tipoDesconto === 3">Sem Desconto</span>
                </div>

                <div style="margin-top: 10px" v-if="dados.tipoDesconto !== 3">
                  <span style="color: grey">{{ dados.tipoDesconto === 1 ? 'Valor' : 'Porcentagem' }} do Desconto</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(8)" />
                  <v-divider />
                  <span style="font-weight: bold" v-if="dados.tipoDesconto === 1">{{ Number(dados.desconto).toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) }}</span>
                  <span style="font-weight: bold" v-if="dados.tipoDesconto === 2">{{ dados.desconto }}%</span>
                </div>

                <div style="margin-top: 10px" v-if="dados.tipoDesconto !== 3">
                  <span style="color: grey">Número de Senhas para receber o Desconto</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(8)" />
                  <v-divider />
                  <span style="font-weight: bold">{{ dados.numeroSenhasDesconto }}</span>
                </div>

                <div style="margin-top: 10px" v-if="descontoTodasSenhas && descontoTodasSenhas === 1 && dados.tipoDesconto !== 3">
                  <span style="color: grey">Categorias que receberão o desconto</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(8)" />
                  <v-divider />
                  <span style="font-weight: bold">Todas</span>
                </div>

                <div style="margin-top: 10px" v-if="descontoTodasSenhas && descontoTodasSenhas === 2 && dados.tipoDesconto !== 3">
                  <span style="font-weight: bold">Categorias que receberão o desconto</span>
                  <v-btn variant="text" icon="mdi-pencil" color="primary" size="x-small" @click="goToStep(8)" />
                  <v-divider />
                  <v-chip-group
                    v-model="dados.categoriasDescontoVaquejada"
                    column
                    color="primary"
                    variant="outlined"
                    multiple
                    active-class="primary"
                  >
                    <div
                      v-for="categoria in dados.categorias"
                      :key="categoria.categoria.id"
                    >
                      <v-chip
                        v-if="dados.categoriasDescontoVaquejada.includes(categoria.categoria.id || 0)"
                        :value="categoria.categoria.id"
                      >
                        {{ categoria.categoria.nome }}
                      </v-chip>
                    </div>
                  </v-chip-group>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions style="height: 10%">
          <v-spacer />
          <v-btn text="Voltar" color="primary" variant="text" @click="dialogCheckout = false" />
          <v-btn text="Salvar" color="success" append-icon="mdi-content-save" variant="elevated" :loading="loading" @click="salvar" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script lang="ts">
  import Quill from 'quill';
  import { DadosCadastroVaquejada } from '@/types/global'
  import { mask } from 'vue-the-mask'
  import DataManager from '@/plugins/data-manager'

  export default {
    name: 'CadastroVaquejada',
    directives: { mask },
    data: () => ({
      stepsCadastro: [
        'Nome e Logo',
        'Descrição',
        'Data de Início e Quantidade de Senhas por Dia',
        'Data de Encerramento, Limite de Senhas e Boi TV',
        'Classificação, Disputas e Localização',
        'Categorias',
        'Comissão e Destinatário Pix',
        'Desconto e Outras Opções',
      ],
      descontoTodasSenhas: null,
      dados: {
        nome: null,
        tipoValor: null,
        valor: null,
        logo: null,
        dataInicio: null,
        dataFim: null,
        quantidadeSenhas: [null],
        totalSenhas: null,
        limiteSenhasVaqueiro: null,
        dataHoraEncerramento: null,
        valorBoi: null,
        numeroClassificacoes: 4,
        numeroDisputas: 8,
        idCity: null,
        categorias: [],
        destinatarioPix: null,
        desconto: null,
        tipoDesconto: 3,
        categoriasDescontoVaquejada: [],
      } as DadosCadastroVaquejada,
      cidades: [],
      estados: [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
        'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
        'SP', 'SE', 'TO'
      ],
      estadoSelecionado: null,
      loadingCidades: false,
      categorias: [],
      dadosCategoria: {
        categoria: null,
        valor: null,
        valorAntecipado: null,
        limiteSenhas: null
      },
      snackbar: {
        active: false,
        color: 'success',
        text: ''
      },
      loading: false,
      valid: false,
      validCategoria: false,
      dialogEditCategoria: {
        active: false,
        categoria: null,
        categoriaConfirmed: null,
        validDialogCategoria: false
      },
      newCategorias: [],
      deleteCategorias: [],
      quilljs: null,
      imageUpload: null,
      firstClickSave: false,
      step: 1,
      destinatariosPix: [],
      loadingDestinatariosPix: false,
      dialogAddDestinatarioPix: false,
      formDestinatarioPix: {
        nome: null,
        chavePix: null,
        contato: null
      },
      loadingFormDestinatarioPix: false,
      dialogCheckout: false,
    }),
    methods: {
      itemProps (item) {
        return {
          title: `${item.nome} - ${item.estado}`,
          value: item.id,
        }
      },
      async listCities () {
        try {
          this.loadingCidades = true;
          this.cidades = [];
          const response = await this.axios.get(`cities/state/${this.estadoSelecionado}`);
          this.cidades = response.data.cities;
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingCidades = false;
        }
      },
      async listCategories () {
        try {
          const response = await this.axios.get('categories');
          this.categorias = response.data.categories;
        } catch (error) {
          console.log(error)
        }
      },
      async salvar () {
        this.firstClickSave = true;
        await this.$refs.form.validate();
        if (!this.valid || this.isErrorLogo) return;
        this.loading = true;
        this.dados.totalSenhas = this.dados.quantidadeSenhas;

        try {
          if (this.$props.editMode) {
            console.log('[Vaquejada] Editando');
            const response = await this.axios.put(`vaquejadas`, {
              ...this.serialize(),
              id: this.$props.vaquejada.id,
              newCategorias: this.newCategorias.map(c => {
                return {
                  idCategoria: c.categoria.id,
                  valor: Number(c.valor),
                  limiteSenhas: Number(c.limiteSenhas)
                }
              }),
              deleteCategorias: this.deleteCategorias
            }, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
            if (response.status === 200) {
              this.$router.back();
            }
          } else {
            console.log('[Vaquejada] Cadastrando');
            const response = await this.axios.post('vaquejadas', this.serialize(), {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
            if (response.status === 201) {
              this.limpar();
              this.$router.back();
            }
          }
          this.dados.categorias = [];
          this.newCategorias = [];
        } catch (error) {
          console.log(error.response.data.error);
          let contextError = '';
          if (this.dados.categorias.length === 0) {
            contextError = ' Vaquejada não pode ficar sem categorias.';
          }
          this.snackbar.active = true;
          this.snackbar.color = 'error';
          this.snackbar.text = 'Erro ao cadastrar vaquejada!' + contextError;
        } finally {
          this.loading = false;
        }
      },
      serialize () {
        if (this.dados.categorias.length === 0) {
          throw new Error('Não é possível cadastrar uma vaquejada sem categorias.');
        }
        return {
          nome: this.dados.nome,
          tipoValor: Number(this.dados.tipoValor),
          valor: Number(this.dados.valor),
          logo: this.dados.logo
            ? this.$props.editMode ? undefined : this.dados.logo
            : this.imageUpload,
          descricao: this.quilljs.root.innerHTML.replace(/\n/g, '<br>'),
          dataInicio: this.dados.dataInicio,
          dataFim: this.generateDataFim(),
          quantidadeSenhas: this.dados.quantidadeSenhas.map(n => Number(n)),
          totalSenhas: Number(this.dados.totalSenhas),
          limiteSenhasVaqueiro: Number(this.dados.limiteSenhasVaqueiro),
          valorBoi: this.dados.valorBoi ? Number(this.dados.valorBoi) : 0,
          numeroClassificacoes: Number(this.dados.numeroClassificacoes),
          numeroDisputas: Number(this.dados.numeroDisputas),
          dataHoraEncerramento: this.getDateFormated(this.dados.dataHoraEncerramento),
          diasSenhas: this.getDiasSenhas(),
          idCity: Number(this.dados.idCity.id),
          categorias: this.dados.categorias.map(c => ({
            idCategoria: this.$props.editMode ? Number(c.id) : Number(c.categoria.id),
            valor: Number(c.valor),
            valorAntecipado: (c.valorAntecipado === undefined || c.valorAntecipado === null) ? undefined : Number(c.valorAntecipado),
            limiteSenhas: Number(c.limiteSenhas)
          })),
          idDestinatarioPix: this.dados.destinatarioPix ? Number(this.dados.destinatarioPix) : 1,
          desconto: this.dados.tipoDesconto !== 3 ? Number(this.dados.desconto) : 0,
          tipoDesconto: Number(this.dados.tipoDesconto === 3 ? 1 : this.dados.tipoDesconto),
          numeroSenhasDesconto: this.dados.tipoDesconto === 3 ? 0 : Number(this.dados.numeroSenhasDesconto || 0),
          categoriaDescontoVaquejada: this.dados.tipoDesconto === 3 ? [] : this.dados.categoriasDescontoVaquejada.map(c => Number(c)) || []
        }
      },
      getDiasSenhas () {
        const dias = [];
        for (let i = 1; i <= this.dados.quantidadeSenhas.length; i++) {
          dias.push({
            id: 0,
            dia: i,
            quantidade: Number(this.dados.quantidadeSenhas[i - 1])
          });
        }
        return dias;
      },
      getDateFormated (date) {
        return DataManager.parseDateToISOString(date);
      },
      limpar () {
        this.$refs.form.reset();
        this.quilljs.root.innerHTML = '';
      },
      async addCategoria () {
        await this.$refs.formCategoria.validate();

        if (this.dadosCategoria.valorAntecipado && this.dadosCategoria.valorAntecipado < 0) {
          this.snackbar = {
            active: true,
            color: 'error',
            text: 'Valor antecipado não pode ser negativo.'
          }
        }

        if (!this.validCategoria) return;
        if (this.$props.editMode) {
          this.newCategorias.push({ ...this.dadosCategoria });
        } else {
          this.dados.categorias.push({ ...this.dadosCategoria });
        }
        this.dadosCategoria = {
          categoria: null,
          valor: null,
          limiteSenhas: null
        }
      },
      openDialogEditCategoria (categoria) {
        this.dialogEditCategoria.active = true;
        this.dialogEditCategoria.categoria = { ...categoria };
        this.dialogEditCategoria.categoriaConfirmed = { ...categoria };
      },
      async editarCategoria () {
        await this.$refs.formEditCategoria.validate();

        if (this.dialogEditCategoria.categoria.valorAntecipado && this.dialogEditCategoria.categoria.valorAntecipado < 0) {
          this.snackbar = {
            active: true,
            text: 'O valor antecipado não pode ser menor que zero.',
            color: 'error',
          }
        }

        if (!this.dialogEditCategoria.validDialogCategoria) return;
        this.dados.categorias = this.dados.categorias.map(c => {
          if (c.categoria.id === this.dialogEditCategoria.categoria.categoria.id) {
            c = this.dialogEditCategoria.categoria;
          }
          return c;
        })
        this.dialogEditCategoria.active = false;
      },
      removeExistingCategoria (index) {
        const categoria = this.dados.categorias[index];
        this.deleteCategorias.push(categoria.id);
        this.dados.categorias.splice(index, 1);
      },
      selecionarImagem () {
        this.$refs.inputImagem.click();
      },
      addQuantidadeSenhas () {
        this.dados.quantidadeSenhas.push(null);
      },
      removeQuantidadeSenhas (index) {
        this.dados.quantidadeSenhas.splice(index, 1);
      },
      generateDataFim () {
        const dataInicio = new Date(this.dados.dataInicio);
        const dataFim = new Date(dataInicio);
        dataFim.setDate(dataFim.getDate() + this.dados.quantidadeSenhas.length - 1);
        return dataFim.toISOString().substring(0, 10);
      },
      initQuill () {
        if (this.quilljs) return;
        this.quilljs = new Quill('#editor-description', {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link']
            ]
          },
          theme: 'snow',
          placeholder: 'Escreva a descrição da vaquejada...',
        });
        if (this.$props.editMode) {
          this.quilljs.root.innerHTML = this.$props.vaquejada.descricao;
        } else {
          const htmlContent = `🏇 <strong>Vaquejada de [Nome do Evento] - [Cidade/UF]</strong><br>
📅 <strong>Data</strong>: [Data do evento]<br><br>
Prepare-se para a maior emoção do sertão! A tradicional Vaquejada de [Nome do Evento] acontecerá nos dias [Datas], no Parque [Nome do Parque], em [Cidade/UF].<br>
🐂 <strong>Premiação total:</strong> R$ [Valor da premiação]<br>
🔰 <strong>Categorias:</strong> [Profissional / Amador / Aspirante / Derby / Feminino / Mirim]<br>
🎵 <strong>Atrações musicais:</strong><br><br>
[Artista 1]<br><br>
[Artista 2]<br><br>
[Artista 3]<br>
(E mais surpresas!)<br><br>
📍 <strong>Local:</strong> Parque [Nome do Parque], [Endereço completo]<br>
⏰ <strong>Início das competições:</strong> [Horário]<br>
🎫 <strong>Ingressos:</strong> [Entrada gratuita / Valor dos ingressos / Onde comprar]<br><br>
Traga sua família e amigos para curtir dias de muita cultura, emoção e forró! A vaquejada é tradição, é festa, é raiz!<br><br>
<strong>Informações:</strong> [Telefone / WhatsApp / Instagram]`;

          const delta = this.quilljs.clipboard.convert({ html: htmlContent });
          this.quilljs.setContents(delta);
        }
      },
      avancar () {
        if (this.step === 8) {
          if (this.$props.editMode) {
            this.salvar();
          } else {
            this.dialogCheckout = true;
          }
        } else {
          this.step = this.step + 1;
        }
      },
      validarEtapa1() {
        const nomeVazio = this.dados.nome === null || this.dados.nome === ''
        const logoVazio = this.dados.logo === null || this.dados.logo === ''
        const semUpload = this.imageUpload === null

        if (nomeVazio) return true
        if (logoVazio && !semUpload) return false
        if (!logoVazio && semUpload) return false
        if (logoVazio || semUpload) return true

        return false
      },
      validarEtapa2() {
        return false
      },
      validarEtapa3() {
        if (this.dados.dataInicio === null || this.dados.dataInicio.length !== 10) {
          return true
        }

        return this.dados.quantidadeSenhas.some(q =>
          q === null || q === '' || q === '0' || q === 0
        )
      },
      validarEtapa4() {
        const encerramentoInvalido = this.dados.dataHoraEncerramento === null || this.dados.dataHoraEncerramento.length !== 16
        const valorInvalido = this.dados.valorBoi === null || this.dados.valorBoi === '' || Number(this.dados.valorBoi) < 0

        return encerramentoInvalido || valorInvalido
      },
      validarEtapa5() {
        const classificacoesInvalidas = this.dados.numeroClassificacoes === null || this.dados.numeroClassificacoes === '' || Number(this.dados.numeroClassificacoes) < 0
        const disputasInvalidas = this.dados.numeroDisputas === null || this.dados.numeroDisputas === '' || Number(this.dados.numeroDisputas) < 0
        const estadoCidadeVazios = this.estadoSelecionado === null || this.dados.idCity === null

        return classificacoesInvalidas || disputasInvalidas || estadoCidadeVazios
      },
      validarEtapa6() {
        return this.dados.categorias.length === 0 && this.newCategorias.length === 0
      },
      validarEtapa7() {
        const tipoValorInvalido = this.dados.tipoValor === null || this.dados.tipoValor === ''
        const valorInvalido = this.dados.valor === null || this.dados.valor === '' || Number(this.dados.valor) < 0

        return tipoValorInvalido || valorInvalido
      },
      validarEtapa8() {
        if (this.dados.tipoDesconto === 3) {
          return false;
        }
        if (this.dados.tipoDesconto === null || this.dados.tipoDesconto === '' || this.dados.desconto === null || this.dados.desconto === '') {
          return true;
        }
        if (this.dados.numeroSenhasDesconto === null || this.dados.numeroSenhasDesconto === '') {
          return true;
        }
        if (this.descontoTodasSenhas === null) {
          return true;
        }
        if (this.descontoTodasSenhas === 1) {
          return false;
        }
        if (this.descontoTodasSenhas === 2 && this.dados.categoriasDescontoVaquejada.length === 0) {
          return true;
        }

        return false;
      },
      selectDestinatarioPixItemProps(item: any) {
        if (item.id === 0) {
          return {
            title: item.nome,
            value: item.id,
            baseColor: 'success',
            color: 'success',
            prependIcon: 'mdi-plus'
          }
        }
        return {
          title: item.nome,
          subtitle: item.chavePix,
          value: item.id
        }
      },
      async listDestinatariosPix() {
        try {
          this.loadingDestinatariosPix = true;
          const response = await this.axios.get('destinatario-pix');
          this.destinatariosPix = response.data.destinatarios;
          console.log(response.data.destinatarios);
          this.destinatariosPix.unshift({ id: 0, nome: 'Adicionar novo', chavePix: 'N/A' });
          console.log(this.destinatariosPix);
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingDestinatariosPix = false;
        }
      },
      async adicionarDestinatarioPix() {
        try {
          this.loadingDestinatariosPix = true;
          const response = await this.axios.post('destinatario-pix', this.formDestinatarioPix);
          this.destinatariosPix.push(response.data);
          this.dados.destinatarioPix = response.data.id;

          this.formDestinatarioPix.nome = '';
          this.formDestinatarioPix.chavePix = '';
          this.formDestinatarioPix.contato = '';
          this.dialogAddDestinatarioPix = false;
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingDestinatariosPix = false;
        }
      },
      goToStep(step: number) {
        this.step = step;
        this.dialogCheckout = false;
      }
    },
    async created () {
      await this.listCategories();
    },
    props: {
      vaquejada: {
        type: Object,
        required: false
      },
      editMode: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      '$props.vaquejada' () {
        if (this.$props.vaquejada) {
          this.estadoSelecionado = this.$props.vaquejada.city.estado;
          this.dados = {
            ...this.$props.vaquejada,
            dataInicio: new Date(this.$props.vaquejada.dataInicio).toISOString().substring(0, 10),
            dataFim: new Date(this.$props.vaquejada.dataFim).toISOString().substring(0, 10),
            dataHoraEncerramento: this.$props.vaquejada.dataHoraEncerramento.substring(0, 16),
            quantidadeSenhas: this.$props.vaquejada.diasSenhas.map(dia => dia.quantidade),
            idCity: {
              id: this.$props.vaquejada.city.id,
              nome: this.$props.vaquejada.city.nome,
              estado: this.$props.vaquejada.city.estado
            },
            valorBoi: Number(this.$props.vaquejada.valorBoi),
            destinatarioPix: this.$props.vaquejada.destinatarioPix,
            categoriasDescontoVaquejada: this.$props.vaquejada.categoriaDescontoVaquejada.map((c) => Number(c.categoria.id))
          };
          this.descontoTodasSenhas = this.$props.vaquejada.categoriaDescontoVaquejada.length > 0 ? 2 : 1;
        }
      },
      async estadoSelecionado () {
        if (this.estadoSelecionado) {
          if (!this.$props.editMode) {
            this.dados.idCity = null;
          }
          await this.listCities();
        }
      },
      step () {
        if (this.step === 2) {
          this.$nextTick(() => {
            this.initQuill();
          });
        }

        if (this.step === 7) {
          this.$nextTick(() => {
            this.listDestinatariosPix();
          });
        }
      },
      'dados.destinatarioPix' () {
        if (this.dados.destinatarioPix === 0) {
          this.dialogAddDestinatarioPix = true;
        }
      },
    },
    computed: {
      getWidthScreen () {
        return window.innerWidth * 0.85;
      },
      activeBtnSalvarCategoria () {
        let active = false;
        if (this.dialogEditCategoria.categoria.limiteSenhas !== this.dialogEditCategoria.categoriaConfirmed.limiteSenhas) {
          active = true;
        }
        if (this.dialogEditCategoria.categoria.valor !== this.dialogEditCategoria.categoriaConfirmed.valor) {
          active = true;
        }
        if (this.dialogEditCategoria.categoria.valorAntecipado !== this.dialogEditCategoria.categoriaConfirmed.valorAntecipado) {
          active = true;
        }
        return active;
      },
      getUrl () {
        return this.getBaseUrl();
      },
      isMobile() {
        return this.$vuetify.display.mobile;
      },
      isErrorLogo() {
        if ((this.dados.logo === null || this.dados.logo === '') && this.imageUpload === null) {
          return true;
        }
        return false;
      },
      disabledBtnSalvar() {
        switch (this.step) {
          case 1: return this.validarEtapa1()
          case 2: return this.validarEtapa2()
          case 3: return this.validarEtapa3()
          case 4: return this.validarEtapa4()
          case 5: return this.validarEtapa5()
          case 6: return this.validarEtapa6()
          case 7: return this.validarEtapa7()
          case 8: return this.validarEtapa8()
          default: return false
        }
      },
      getImageUploadURL() {
        if (this.imageUpload) {
          return URL.createObjectURL(this.imageUpload);
        }
        return '';
      },
      getDescricao() {
        return this.quilljs.root.innerHTML.replace(/\n/g, '<br>');
      },
      getDiasSenhasWithDate() {
        const dias = [];
        const diasSenhas = this.getDiasSenhas();
        for (let i = 0; i < diasSenhas.length; i++) {
          const dataInicio = new Date(this.dados.dataInicio);
          console.log(dataInicio.toDateString());
          dias.push({
            data: new Date(dataInicio.setDate(dataInicio.getDate() + i)).toISOString().substring(0, 10).split('-').reverse().join('/'),
            quantidade: diasSenhas[i].quantidade
          });
        }
        return dias;
      },
      getCidade() {
        if (this.dados.idCity) {
          return this.cidades.find(c => c.id === this.dados.idCity.id).nome + ' - ' + this.estadoSelecionado;
        }
        return null;
      }
    }
  }
</script>

<style scoped>

</style>
